/**
* Scrolling Image Collage JS
* -----------------------------------------------------------------------------
*
* All the JS for the Scrolling Image Collage component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'scrolling-image-collage',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.scrolling-image-collage' ).length ) {
        $( '.scrolling-image-collage' ).each( function( index, element ) {
          const slideImages = $( element ).find( '.js-scroll-slide' );
          $( slideImages ).each( function( index, element ) {
            gsap.to( $( element ), {
              yPercent: 20,
              scrollTrigger: {
                trigger: $( element ),
                start: 'top-=50 center',
                scrub: 0.5,
              },
            } );
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'scrolling-image-collage', COMPONENT );
} )( app );
